module.exports = __webpack_public_path__ + "img/icon_private_overview03.b2e18b3a.svg";